import { observable, toJS } from 'mobx';

import { EAjaxFunctions, EResponseStatus } from '@enums';

import { Log } from '@utils';

import { Api } from '@api';

import { AppsStore } from '../AppsStore';
import { getAdaptedShowcase } from './utils';

import { ICGIUrlOptions } from '@interfaces';

import { IShowcaseStore, IShowcaseData } from './types';

export class ShowcaseStore extends AppsStore {

	constructor() {
		super(EAjaxFunctions.APPS_SHOWCASE);
	}

	@observable
	data: IShowcaseData = {
		apps: [],
		total: 0,
	};

	async fetchData(
		options: ICGIUrlOptions,
		isFetchMore?: boolean,
	) {
		let showcaseResponse: IShowcaseData | null = null;

		this.status = EResponseStatus.PENDING;

		try {
			const response = await Api.apps.fetchShowcase(this.func, { target: 'catalog', ...options });

			if (response && typeof response !== 'string' && Array.isArray(response)) {
				this.status = EResponseStatus.OK;
				if (!isFetchMore) {
					showcaseResponse = getAdaptedShowcase(response);
				}
			} else {
				this.status = EResponseStatus.OK;
				Log.error(`Couldn't get apps by ${this.func}. The response is incorrect: ${JSON.stringify(response)}`);
			}
		} catch (err) {
			Log.error(`Failed in getting apps in ShowcaseStore; Error: ${err}`);
			this.status = EResponseStatus.ERROR;
		}

		return showcaseResponse;
	};

	toJSON(): IShowcaseStore {
		return {
			data: this.data,
			status: this.status,
		};
	}

	fromJSON(store: IShowcaseStore) {
		this.data = { ...toJS(this.data), ...store.data };
		this.status = store.status;
	}

}
